import React, { useContext, useEffect } from "react";
import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import axios from "../../../../context/axios";
import EditIcon from "@mui/icons-material/Edit";
import ComptableContext from "../../../../context/ComptableContext";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
export default function UpdateModel({ data, appareil_id }) {
  const [UpdateModel, setUpdateModel] = useState({});
  const { getTypesgps, getTypesacc, getTypessim } =
    useContext(ComptableContext);

  const [show, setShow] = useState(false);
  const [errors, setErrors] = useState();
  const handleShow = () => setShow(true);
  const handleClose = () => {
    setErrors();
    setShow(false);
  };
  useEffect(() => {
    setUpdateModel({
      modele_id: data.id,
      newNameModele: data.nameModele,
    });
  }, [show]);
  const handleUpdateModel = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setUpdateModel({ ...UpdateModel, [name]: value });
  };
  const showSuccessMessage = (message) => {
    toast.success(message, {
      position: toast.POSITION.TOP_RIGHT,
    });
  };
  const callGetTypeFun = (appareil_id) => {
    switch (appareil_id) {
      case "1":
        getTypesgps();
        break;
      case "2":
        getTypessim();
        break;
      case "3":
        getTypesacc();
        break;
    }
  };
  const updateModelSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        "/api/comptable/updateModel",
        UpdateModel
      );
      callGetTypeFun(appareil_id);
      handleClose();
      showSuccessMessage(response.data);
      setUpdateModel({});
    } catch (error) {
      setErrors(error.response.data.errors);
    }
  };

  return (
    <div>
      <div>
        <Button variant="primary" onClick={handleShow}>
          <EditIcon />
        </Button>
      </div>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Modifier Modele</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form noValidate method="POST" onSubmit={updateModelSubmit}>
            <Row className="mb-3">
              <Form.Group as={Col} md="12" controlId="validationCustom01">
                <Form.Label>Nom: </Form.Label>
                <Form.Control
                  required
                  autoComplete="off"
                  type="text"
                  name="newNameModele"
                  value={UpdateModel.newNameModele}
                  onChange={handleUpdateModel}
                />
                <span style={{ color: "red" }}>{errors?.newNameModele[0]}</span>
              </Form.Group>
            </Row>
            <Modal.Footer>
              <Button type="submit" variant="primary">
                ENREGISTRER MODIFICATION
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
}
